import React from "react";
import { Link } from "umi";
import { ShipmentStatusMap } from "@/utils/enum";
import styles from "./styles.less";

const LiveMarker = ({ status, detailsLinkUrl, onMarkerClick }) => {
  return (
    <Link to={detailsLinkUrl}>
      <div className={styles[`pulseIcon${ShipmentStatusMap[status]}`]}></div>
    </Link>
  );
};

export default LiveMarker;
